import React, { useEffect, useState } from "react";

import LoaderSvg from "@components/icons/loader-svg";

type Props = {
  children?: React.ReactNode;
  isLoading?: boolean;
};

function EmptyQueryHandler({ children, isLoading }: Props) {
  const [isLoaderWaitLongTime, setIsLoaderWaitLongTime] =
    useState<boolean>(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!isLoading) {
        return;
      }
      setIsLoaderWaitLongTime(true);
    }, 5000);
    return () => clearTimeout(timer);
  }, [isLoading]);

  if (isLoading && !isLoaderWaitLongTime) {
    return null;
  }

  if (isLoading && isLoaderWaitLongTime) {
    return (
      <div className='dark:bg-grey-dark-light fixed top-0 left-0 right-0 bottom-0 z-10 mx-auto  my-0 flex items-center justify-center bg-grey-light opacity-60'>
        <div className='h-[48px] w-[48px] animate-rotate'>
          <LoaderSvg classNameProps='fill-blue' width={48} height={48} />
        </div>
      </div>
    );
  }

  // eslint-disable-next-line
  return <>{children}</>;
}

export default EmptyQueryHandler;
